//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../GeometricUtilities/GeometricUtilities.DepthSkewBuilder.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.Rebuild.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AlternateSolutions",1,0],[1,"AngleLaw",0,"GeometricUtilities.LawBuilder",0],[1,"ApexCurve",0,"Section",0],[0,"BodyTypePreference",1,0],[0,"CircularTypeMode",1,0],[0,"ConicTypeMode",1,0],[0,"ControlRegion",1,0],[0,"CreateApexCurve",1,0],[0,"CubicTypeMode",1,0],[1,"EndContinuity",0,"GeometricUtilities.Continuity",0],[1,"EndDepthSkew",0,"GeometricUtilities.DepthSkewBuilder",0],[0,"EndDirection",1,0],[1,"EndFace",0,"ScCollector",0],[1,"EndHighlightCurve",0,"Section",0],[1,"EndShapeCurve",0,"Section",0],[1,"EndSlopeCurve",0,"Section",0],[1,"EntireDepthSkew",0,"GeometricUtilities.DepthSkewBuilder",0],[0,"G0Tolerance",1,0],[0,"G1Tolerance",1,0],[0,"G2Tolerance",1,0],[0,"LinearTypeMode",1,0],[1,"RadiusLaw",0,"GeometricUtilities.LawBuilder",0],[1,"Rebuild",0,"GeometricUtilities.Rebuild",0],[1,"RhoLaw",0,"GeometricUtilities.LawBuilder",0],[1,"SectionEndGuide",0,"Section",0],[1,"SectionInteriorGuide1",0,"Section",0],[1,"SectionInteriorGuide2",0,"Section",0],[1,"SectionInteriorGuide3",0,"Section",0],[0,"SectionMethodCircleTangent",1,0],[0,"SectionMethodFilletBridge",1,0],[0,"SectionMethodRho",1,0],[1,"SectionOrientationGuide",0,"Section",0],[1,"SectionStartGuide",0,"Section",0],[1,"ShoulderCurve",0,"Section",0],[0,"SlopeControl",1,0],[0,"SpineEndFlowDirection",1,0],[1,"SpineSection",0,"Section",0],[0,"SpineStartFlowDirection",1,0],[0,"SpineType",1,0],[0,"SpineVector",1,"Direction",0],[0,"SplitAlongGuide",1,0],[1,"StartContinuity",0,"GeometricUtilities.Continuity",0],[1,"StartDepthSkew",0,"GeometricUtilities.DepthSkewBuilder",0],[0,"StartDirection",1,0],[1,"StartFace",0,"ScCollector",0],[1,"StartHighlightCurve",0,"Section",0],[1,"StartShapeCurve",0,"Section",0],[1,"StartSlopeCurve",0,"Section",0],[0,"Type",1,0],[0,"UDegree",1,0]],[[["params"],"SetSolutionHelpParams",{},1,0],[["points"],"SetSolutionHelpPositions",{},1,0],[["supports","supportSenses"],"SetHelpPointSupports",{},2,0]],[]];
SPLM.Features.SectionSurfaceBuilderEx = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SectionSurfaceBuilderEx";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SectionSurfaceBuilderEx.Types = Object.freeze({
    "Conic" : "Conic", "Circular" : "Circular", "Cubic" : "Cubic", "Linear" : "Linear"});

SPLM.Features.SectionSurfaceBuilderEx.ConicType = Object.freeze({
    "Shoulder" : "Shoulder", "Rho" : "Rho", "Hilite" : "Hilite", "FourPointSlope" : "FourPointSlope", "FivePoint" : "FivePoint"});

SPLM.Features.SectionSurfaceBuilderEx.CubicType = Object.freeze({
    "TwoSlopes" : "TwoSlopes", "FilletBridge" : "FilletBridge"});

SPLM.Features.SectionSurfaceBuilderEx.CircularType = Object.freeze({
    "ThreePoint" : "ThreePoint", "TwoPointRadius" : "TwoPointRadius", "TwoPointSlope" : "TwoPointSlope", "RadiusAngleArc" : "RadiusAngleArc", "TangentpointTangent" : "TangentpointTangent", "CenterRadius" : "CenterRadius", "CenterPoint" : "CenterPoint", "CenterTangent" : "CenterTangent", "TangentRadius" : "TangentRadius", "TangentTangentRadius" : "TangentTangentRadius"});

SPLM.Features.SectionSurfaceBuilderEx.LinearType = Object.freeze({
    "PointAngle" : "PointAngle", "TangentTangent" : "TangentTangent"});

SPLM.Features.SectionSurfaceBuilderEx.SlopeControlType = Object.freeze({
    "ByApex" : "ByApex", "ByCurves" : "ByCurves", "ByFaces" : "ByFaces"});

SPLM.Features.SectionSurfaceBuilderEx.ControlRegionType = Object.freeze({
    "Entire" : "Entire", "Start" : "Start", "End" : "End"});

SPLM.Features.SectionSurfaceBuilderEx.SectionMethodCircleTangentType = Object.freeze({
    "FilletArc" : "FilletArc", "CoverArc" : "CoverArc"});

SPLM.Features.SectionSurfaceBuilderEx.SectionMethodRhoType = Object.freeze({
    "Rho" : "Rho", "LeastTension" : "LeastTension"});

SPLM.Features.SectionSurfaceBuilderEx.SectionMethodFilletBridgeType = Object.freeze({
    "Continuity" : "Continuity", "InheritShape" : "InheritShape"});

SPLM.Features.SectionSurfaceBuilderEx.Spine = Object.freeze({
    "ByVector" : "ByVector", "ByCurve" : "ByCurve"});

SPLM.Features.SectionSurfaceBuilderEx.SpineStartFlowType = Object.freeze({
    "NotSpecified" : "NotSpecified", "Perpendicular" : "Perpendicular", "IsoLineU" : "IsoLineU", "IsoLineV" : "IsoLineV"});

SPLM.Features.SectionSurfaceBuilderEx.SpineEndFlowType = Object.freeze({
    "NotSpecified" : "NotSpecified", "Perpendicular" : "Perpendicular", "IsoLineU" : "IsoLineU", "IsoLineV" : "IsoLineV"});

SPLM.Features.SectionSurfaceBuilderEx.UDegreeType = Object.freeze({
    "Conic" : "Conic", "Cubic" : "Cubic", "Quintic" : "Quintic"});

SPLM.Features.SectionSurfaceBuilderEx.BodyType = Object.freeze({
    "Solid" : "Solid", "Sheet" : "Sheet"});

export default SPLM;